import "./TransferTraker.css";
import { TransactionStatusEnum } from "../TransactionStatus";

const TransferTraker = ({ transaction }) => {
    const { status, updatedAt } = transaction;

    const is = (step) => {
        switch (step) {
            case TransactionStatusEnum.PROCESSING:
                return [TransactionStatusEnum.PROCESSING, TransactionStatusEnum.READY, TransactionStatusEnum.PAID].includes(status);
            case TransactionStatusEnum.READY:
                return [TransactionStatusEnum.READY, TransactionStatusEnum.PAID].includes(status);
            case TransactionStatusEnum.PAID:
                return status === TransactionStatusEnum.PAID;
            default:
                return false;
        }
    };

    const paidAt =
        status === TransactionStatusEnum.PAID && updatedAt
            ? new Date(updatedAt).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            })
            : null;

    return (
        <div className="transfer-tracker mt-4">
            <h5 className="mb-3">Transfer Tracker</h5>

            <div className={`step d-flex align-items-start gap-3 ${is(TransactionStatusEnum.PROCESSING) ? "active" : ""}`}>
                <div className="circle mt-1" />
                <div className="step-content">
                    <strong className={is(TransactionStatusEnum.PROCESSING) ? "text-success" : ""}>Processing</strong>
                    <p className="mb-0 text-muted">Payment received and is being processed</p>
                </div>
            </div>

            <div className={`step d-flex align-items-start gap-3 ${is(TransactionStatusEnum.READY) ? "active" : ""}`}>
                <div className="circle mt-1" />
                <div className="step-content">
                    <strong className={is(TransactionStatusEnum.READY) ? "text-success" : ""}>Ready</strong>
                    <p className="mb-0 text-muted">Transfer ready for payment</p>
                </div>
            </div>

            <div className={`step d-flex align-items-start gap-3 ${is(TransactionStatusEnum.PAID) ? "active" : ""}`}>
                <div className="circle mt-1" />
                <div className="step-content">
                    <strong className={is(TransactionStatusEnum.PAID) ? "text-success" : ""}>Paid</strong>
                    <p className="mb-0 text-muted">
                        Recipient has received the money
                    </p>

                    {paidAt && <small className="text-muted">Marked paid: <span className="text-success fw-semibold">{paidAt}</span></small>}

                </div>
            </div>
        </div>
    );
};

export default TransferTraker;
